import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertCircle } from 'lucide-react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../ui/alert-dialog';

const CalendriersDeleteDialog = ({ isDeleteDialogOpen, setIsDeleteDialogOpen, selectedCalendar, handleDeleteCalendar }) => {
  const { t } = useTranslation();

  return (
    <AlertDialog open={isDeleteDialogOpen} onOpenChange={setIsDeleteDialogOpen}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{t("holidayCalendarComponents.deleteDialog.title")}</AlertDialogTitle>
        <AlertDialogDescription>
          {t("holidayCalendarComponents.deleteDialog.description", { name: selectedCalendar?.name })}
          {selectedCalendar?.employees_count > 0 && (
            <div className="mt-2 p-2 bg-orange-950/20 border border-orange-900/40 rounded">
              <AlertCircle className="inline h-4 w-4 text-orange-400 mr-1" />
              <span className="text-muted-foreground text-sm">
                {t("holidayCalendarComponents.deleteDialog.assignedWarning", { count: selectedCalendar.employees_count })}
              </span>
            </div>
          )}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>{t("holidayCommon.cancel")}</AlertDialogCancel>
        <AlertDialogAction onClick={handleDeleteCalendar} className="bg-red-600 hover:bg-red-700">
          {t("holidayCalendarComponents.deleteDialog.delete")}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
    </AlertDialog>
  );
};

export default CalendriersDeleteDialog;
